export default function (text) {
	text = text.toLowerCase();
	const strSChar = 'áàãâäéèêëíìîïóòõôöúùûüç ()?>:<.;,/';
	const strNoSChars = 'aaaaaeeeeiiiiooooouuuuc___________';
	let newStr = '';
	for (var i = 0; i < text.length; i++) {
		if (strSChar.indexOf(text.charAt(i)) != -1) {
			newStr += strNoSChars.substr(strSChar.search(text.substr(i, 1)), 1);
		} else {
			newStr += text.substr(i, 1);
		}
	}
	return newStr;
}



// WEBPACK FOOTER //
// ./src/assets/js/parseId.js